import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TawkToChat = () => {
    const location = useLocation();

    useEffect(() => {
        const shouldMobileHideChat = /\/[^/]+\/(sections|items|favorites|orders|feedback|cart|menus|trackorderstatus|verify-phone|profile|labels|order_thanks|privacy-policy|terms-and-conditions|transactions)$/.test(location.pathname);
        const shouldDahboardHideChat = /\/(trackorderstatus)$/.test(location.pathname);
        if (shouldMobileHideChat || shouldDahboardHideChat) {
            return;
        }
        const Tawk_API = window.Tawk_API || {};
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://embed.tawk.to/66f1ac71e5982d6c7bb34117/1i8g0j6vg';
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [location.pathname]);

    return null;
};

export default TawkToChat;
